export const COUNTRIES = ['BE', 'NL', 'FR', 'DE', 'IT', 'LU', 'US', 'TR']
export default (t, countries = COUNTRIES) =>
  countries.map(option => ({
    value: option,
    label: t(`options.country.${option}`),
  }))
